import { Route } from '@angular/router';
import { NotFoundComponent } from '@rma/layout/status-pages';

export const fallbackRoutes: Route[] = [
  {
    path: '**',
    title: 'Page not found',
    component: NotFoundComponent,
  },
];
